import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useDispatch, useSelector } from 'react-redux';
// import GavelIcon from '@mui/icons-material/Gavel';
// import MoreTimeIcon from '@mui/icons-material/MoreTime';
// import AutoDeleteIcon from '@mui/icons-material/AutoDelete';
import { enrolledAuctionsAPI } from '../../../apis';
import { showSnackbar } from '../../../store/slices/common.slice';
import {
  APIResponse,
  Auction,
  ListingResponse,
  TypeSnackbarPayload,
} from '../../../utilities/types';
import DatagridLoader from '../../elements/datagrid-loader.element';
import {
  getFormattedDate,
  getFormattedPrice,
  getFormattedQuantity,
  parseIntoNumber,
  prepareAndGetMediaURL,
} from '../../../utilities/helper';
import { RootState } from '../../../store';
import FormModal from '../../modals/form.modal';
// import CustomSwal from '../../elements/custom-swal.element';
import BidWidget from '../bid.widget';
import AutoBidRequestWidget from '../auto-bid-request.widget';
import useNavigateHook from '../../../hooks/navigate.hook';

interface EnrolledAuctionGridWidgetProps {
  // eslint-disable-next-line react/no-unused-prop-types
  refresh: number;
}

const EnrolledAuctionGridWidget: React.FC<EnrolledAuctionGridWidgetProps> = () => {
  const dispatch = useDispatch();

  const { doNavigate } = useNavigateHook();

  const { user } = useSelector((state: RootState) => state.auth);
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [showAuctionDetailModal, setShowAuctionDetailModal] = useState<boolean>(false);
  const [selectedAuction, setSelectedAuction] = useState<Auction | null>(null);
  // const [isPlacingBid, setIsPlacingBid] = useState<boolean>(false);
  const [openAutoBidForm, setOpenAutoBidForm] = useState<boolean>(false);

  const pageSize = 20;

  // Simulate API call (replace with your real API)
  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = (await enrolledAuctionsAPI({
        user_id: user?.id,
      })) as APIResponse<ListingResponse>;
      if (response.status) {
        const items: any = (Array.isArray(response.data) ? response.data : []).map((item: any) => {
          let bid_amount = '--';
          if (item?.last_bid) {
            bid_amount = getFormattedPrice(item?.last_bid.amount);
          }
          return {
            ...item,
            item_name: item.item?.name,
            quantity: getFormattedQuantity(item.quantity, item.quantity_unit),
            start_time_raw: item.start_time,
            end_time_raw: item.end_time,
            start_time: getFormattedDate(item.start_time),
            end_time: getFormattedDate(item.end_time),
            image: item.item?.image,
            bid_amount,
          };
        });
        setRows(items);
        setRowCount(items.length);
      }
    } catch (err: any) {
      const snakbarpayload: TypeSnackbarPayload = { severity: 'error', message: err.message };
      if (err?.data?.message) {
        snakbarpayload.message = err?.data?.message;
      } else if (err?.statusText) {
        snakbarpayload.message = err?.statusText;
      }
      dispatch(showSnackbar(snakbarpayload));
    }
    setLoading(false);
  }, [dispatch, user?.id]);

  // const placeBid = useCallback(
  //   async (auction: Auction) => {
  //     const nextBidMinAmount =
  //       parseIntoNumber(auction?.current_price) + parseIntoNumber(auction?.increment_price);
  //     setIsPlacingBid(true);
  //     const result = await CustomSwal.fire({
  //       title: 'Place Bid',
  //       text: 'Please enter the bid amount',
  //       html: (
  //         <Stack
  //           justifyContent="space-between"
  //           direction={{ xs: 'column', md: 'row' }}
  //           gap={2}
  //           sx={{
  //             backgroundColor: '#E8F5E9',
  //             borderRadius: 2,
  //             p: 2,
  //             my: 2,
  //           }}
  //         >
  //           <Box>
  //             <Typography variant="subtitle2" color="text.secondary">
  //               Current Bid:
  //             </Typography>
  //             <Typography variant="h5" color="success.main" fontWeight="bold">
  //               {getFormattedPrice(parseIntoNumber(auction?.current_price))}
  //             </Typography>
  //           </Box>
  //           <Box>
  //             <Typography variant="subtitle2" color="text.secondary">
  //               Total Quantity:
  //             </Typography>
  //             <Typography variant="h5" color="success.main" fontWeight="bold">
  //               {auction?.quantity}
  //             </Typography>
  //           </Box>
  //         </Stack>
  //       ),
  //       input: 'number',
  //       inputValue: nextBidMinAmount,
  //       inputPlaceholder: 'Enter your bid price',
  //       inputAttributes: {
  //         min: nextBidMinAmount.toString(),
  //         step: '1',
  //       },
  //       allowOutsideClick: false,
  //       showCancelButton: true,
  //       preConfirm: (value) => {
  //         const price = parseIntoNumber(value);
  //         if (price <= 0) {
  //           CustomSwal.showValidationMessage('Please enter a valid price value.');
  //           return false;
  //         }
  //         if (nextBidMinAmount >= price) {
  //           CustomSwal.showValidationMessage(
  //             `Your bid must be greater than ${getFormattedPrice(nextBidMinAmount)}`
  //           );
  //           return false;
  //         }
  //         return price;
  //       },
  //     });
  //     if (result.isConfirmed) {
  //       try {
  //         const payload = {
  //           auction_id: auction?.id,
  //           bidder_id: user?.id,
  //           network_info: await getBrowserNetworkInfo(),
  //           amount: result.value,
  //         };
  //         const response = (await placeBidAPi(payload)) as APIResponse<Auction>;
  //         if (response.status) {
  //           CustomSwal.fire({
  //             icon: 'success',
  //             title: 'Bid Place successfully',
  //           });
  //           fetchData();
  //         }
  //       } catch (err: any) {
  //         const snakbarpayload: TypeSnackbarPayload = { severity: 'error', message: err.message };
  //         if (err?.data?.message) {
  //           snakbarpayload.message = err?.data?.message;
  //         } else if (err?.statusText) {
  //           snakbarpayload.message = err?.statusText;
  //         }
  //         dispatch(showSnackbar(snakbarpayload));
  //       }
  //     }
  //     setIsPlacingBid(false);
  //   },
  //   [dispatch, fetchData, user?.id]
  // );

  const viewDetail = useCallback((auction: Auction) => {
    doNavigate(`/auction-detail.html?id=${auction.id}`);
    // setSelectedAuction(auction);
    // setShowAuctionDetailModal(true);
  }, [doNavigate]);

  // const showAutoBidForm = useCallback(async (auction: Auction) => {
  //   setSelectedAuction(auction);
  //   setOpenAutoBidForm(true);
  // }, []);

  const getBidPlaceCTAForAuction = (auction: Auction) => {
    if (auction.bid_application.status === 'pending')
      return <Typography variant='body2'>Waiting for Approval</Typography>;

    return <Button
      variant="contained"
      size="small"
      color="info"
      title="Click to view auction detail"
      onClick={() => viewDetail(auction)}
      sx={{ minWidth: 'auto' }}
    >
      View Detail
    </Button>

    // Commented below auction, we will below UI when multiple auction will run in real env
    // const autoBid = auction.auto_bid_detail;

    // return (
    //   <Stack flexDirection="row" gap={1}>
    //     {!isAuctionLive(auction?.start_time_raw, auction?.end_time_raw)
    //       ? (
    //         <Button
    //           variant="contained"
    //           size="small"
    //           color="secondary"
    //           title="Click to view auction detail"
    //           onClick={() => viewDetail(auction)}
    //           sx={{ minWidth: 'auto' }}
    //         >
    //           <GavelIcon fontSize="inherit" />
    //         </Button>
    //       ) : (
    //         <Button
    //           variant="contained"
    //           size="small"
    //           color="secondary"
    //           title="Click to place bid"
    //           onClick={() => placeBid(auction)}
    //           disabled={isPlacingBid}
    //           sx={{ minWidth: 'auto' }}
    //         >
    //           <GavelIcon fontSize="inherit" />
    //         </Button>
    //       )}
    //     <Button
    //       variant="contained"
    //       size="small"
    //       color="info"
    //       title={autoBid ? 'Click to update auto bid' : 'Click to set auto bid'}
    //       onClick={() => showAutoBidForm(auction)}
    //       disabled={isPlacingBid}
    //       sx={{ minWidth: 'auto' }}
    //     >
    //       <MoreTimeIcon fontSize="inherit" />
    //     </Button>
    //     {autoBid && (
    //       <Button
    //         variant="contained"
    //         size="small"
    //         color="error"
    //         title="Click to remove auto bid"
    //         onClick={() => showAutoBidForm(auction)}
    //         disabled={isPlacingBid}
    //         sx={{ minWidth: 'auto' }}
    //       >
    //         <AutoDeleteIcon fontSize="inherit" />
    //       </Button>
    //     )}
    //   </Stack>
    // );
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // Columns Definition
  const columns = [
    {
      field: 'custom_id',
      headerName: 'ID',
      width: 70,
    },
    {
      field: 'title',
      headerName: 'Title',
      flex: 1,
      renderCell: (params: any) => (
        <Button
          variant="text"
          size="small"
          color="info"
          title="Click to view full detail"
          onClick={() => viewDetail(params.row)}
        >
          {params.value}
        </Button>
      ),
    },
    {
      field: 'image',
      headerName: 'Image',
      width: 100,
      cellClassName: 'item-img-cell',
      renderCell: (params: any) => (
        <img
          alt="item"
          src={prepareAndGetMediaURL(params.value)}
          style={{ maxWidth: 60, height: 'auto', maxHeight: 60, objectFit: 'cover' }}
        />
      ),
    },
    { field: 'item_name', headerName: 'Item Name', flex: 1 },
    { field: 'quantity', headerName: 'Quantity' },
    {
      field: 'end_time',
      headerName: 'End Time',
      width: 200,
    },
    {
      field: 'price',
      headerName: 'Current Bid',
      flex: 1,
      renderCell: (params: any) => {
        return getFormattedPrice(params.row.current_price);
      },
    },
    {
      field: 'bid_amount',
      headerName: 'Your Bid',
      width: 120,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      sortable: false,
      renderCell: (params: any) => getBidPlaceCTAForAuction(params.row),
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      <DataGrid
        rows={rows}
        columns={columns.map((col) => ({ ...col, sortable: false }))}
        pageSizeOptions={[pageSize]}
        paginationMode="server"
        paginationModel={{ page, pageSize }}
        rowCount={rowCount}
        onPaginationModelChange={(newModel: any) => setPage(newModel.page)}
        loading={loading}
        disableRowSelectionOnClick
        disableColumnFilter
        disableColumnMenu
        disableColumnSelector
        slots={{
          loadingOverlay: DatagridLoader,
        }}
        sx={{
          // '& .MuiDataGrid-row': {
          //   maxHeight: 'inherit !important',
          //   '--height': '75px !important',
          // },
          '& .item-img-cell': {
            display: 'flex',
          },
        }}
      />
      {showAuctionDetailModal && selectedAuction && (
        <FormModal
          open={showAuctionDetailModal}
          onClose={() => {
            setShowAuctionDetailModal(false);
            setSelectedAuction(null);
          }}
          size="md"
          title="Auction Detail"
        >
          <BidWidget auction_id={parseIntoNumber(selectedAuction.id)} />
        </FormModal>
      )}
      {openAutoBidForm && selectedAuction && (
        <FormModal
          open={openAutoBidForm}
          onClose={() => {
            setOpenAutoBidForm(false);
            setSelectedAuction(null);
          }}
          size="xs"
          title="Set Auto Bid"
        >
          <AutoBidRequestWidget
            auction={selectedAuction}
            onSuccess={() => {
              setOpenAutoBidForm(false);
              setSelectedAuction(null);
            }}
          />
        </FormModal>
      )}
    </Box>
  );
};

export default EnrolledAuctionGridWidget;
